import { numberMoney } from 'Data/format.js'
import { getPayorShareAfterDiscounts } from 'Data/payment-plan.js'

export function getPayorShareAfterDiscountsFormatted(payor, payment_plan) {
  return numberMoney(getPayorShareAfterDiscounts(payor, payment_plan))
}
